import { render, staticRenderFns } from "./TourSpecifications.vue?vue&type=template&id=6cd8dcc7&"
import script from "./TourSpecifications.vue?vue&type=script&lang=js&"
export * from "./TourSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourSpecifications.vue"
export default component.exports